import React from 'react';
import { classnames } from 'tailwindcss-classnames';

export type SpinnerSize = "xs" | "sm" | "md" | "lg" | "xl"

export interface SpinnerProps {
  emptyColor?: string
  color?: string
  label?: string
  size?: SpinnerSize;
}

const BUTTON_SPINNER_STYLE = classnames(
  "inline-block",
  "border-current",
  "rounded-full",
  "border-2",
);

const SIZES = {
  xs: classnames('w-3', 'h-3'),
  sm: classnames('w-4', 'h-4'),
  md: classnames('w-6', 'h-6'),
  lg: classnames('w-8', 'h-8'),
  xl: classnames('w-12', 'h-12'),
};

const ButtonSpinner = ({
  emptyColor = "transparent",
  label = 'Loading...',
  size = "md",
  color,
}: SpinnerProps) => {
  const classes = classnames(BUTTON_SPINNER_STYLE, SIZES[size])
  return (
    <div
      className={`animation-spin animation-linear animation-infinite animation-1s ${classes}`}
      style={{
        borderBottomColor: emptyColor,
        borderLeftColor: emptyColor,
        color,
      }}
    >
      <span className="sr-only">{label}</span>
    </div>
  )
}

export default ButtonSpinner;